import { NavigateFunction, Location as ReactRouterLocation } from 'react-router-dom';
  

export function getQueryParam(location: string | URL | Location, key: string): string | null {
  const queryParams = new URL(location as string).searchParams;
  return queryParams.get(key);
}

export function navigateFn(props: {
  location: ReactRouterLocation;
  navigate: NavigateFunction;
}): (pathname: string, search?: string) => void {
  return (pathname: string, search?: string) => {
    const link = createLink({ location: props.location, pathname, search });
    props.navigate(link);
  };
}

export function addQueryParams(location: string | URL | Location, params: Record<string, string>): string {
  const url = new URL(location as string);
  const queryParams = url.searchParams;

  const keys = Object.keys(params);
  keys.forEach((key) => {
    queryParams.append(key, params[key]);
  });

  let newUrl = url.origin + url.pathname;

  if (queryParams.toString()) {
    newUrl += `?${queryParams.toString()}`;
  }

  newUrl += url.hash;
  return newUrl;
}

export function removeQueryParams(location: string | URL | Location, keys: string[]): string {
  const url = new URL(location as string);
  const queryParams = url.searchParams;

  keys.forEach((key) => {
    queryParams.delete(key);
  });

  let newUrl = url.origin + url.pathname;

  if (queryParams.toString()) {
    newUrl += `?${queryParams.toString()}`;
  }

  newUrl += url.hash;
  return newUrl;
}

export const isAbsoluteUrl = (url: string): boolean => /^https?:/.test(url);

export function createLinkWithSearch({
  location,
  pathname,
  search,
}: {
  location: ReactRouterLocation;
  pathname: string;
  search: string;
}): Partial<ReactRouterLocation> {
  return {
    pathname,
    search: search || location.search,
    hash: location.hash,
    state: location.state,
  };
}

export function createLink({
  location,
  pathname,
  search,
}: {
  location: ReactRouterLocation;
  pathname: string;
  search?: string;
}): Partial<ReactRouterLocation> {
  return {
    pathname,
    search,
    hash: location.hash,
    state: location.state,
  };
}